import { systemService } from '@euler/services/factory';
import { BehaviorSubject, Subject } from 'rxjs';

export const systemUnderMaintenance$ = new BehaviorSubject<boolean>(false);

/** Fires when maintenance mode transitions from true to false. */
export const maintenanceResolved$ = new Subject<void>();

export async function checkSystemStatus(): Promise<void> {
  try {
    const result = await systemService.getSystemStatus();
    const wasMaintenance = systemUnderMaintenance$.value;
    const isMaintenance = result.status.maintenance;
    systemUnderMaintenance$.next(isMaintenance);
    if (wasMaintenance && !isMaintenance) {
      maintenanceResolved$.next();
    }
  } catch {
    // fail-open: do not change maintenance state on error
  }
}
